<template>
  <radio-buttons
    :value="value"
    @input="(val) => $emit('input', val)"
    :options="targetTypes"
    :on-select="onSelect"
    :disabled="disabled"
  />
</template>

<script>
import RadioButtons from '@/components/common/radioButtons'
import {TARGET_TYPE} from '@/appLogic/targets/Constants'

const UPLOAD_TARGET_TYPES = [
  {
    value: TARGET_TYPE.PID,
    name: 'PID'
  }
]
export default {
  components: {
    RadioButtons
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onSelect: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      targetTypes: UPLOAD_TARGET_TYPES
    }
  },
  watch: {
    value () {
      this.onSelect()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// UploadTargetRadioButtons.vue?485529a5